import * as classnames from "classnames";
import * as React from "react";

import { Alert, Button, Msg, Portal } from "@shared/components";

import SubmitExam from "../../../modals/submitExam/SubmitExam.connect";

export interface SubmitExamAlertProps {
  submitExam?: () => void;
  showCloseButton?: boolean;
  className?: string;
  disabled?: boolean;
}

/**
 * Page component
 */
export const SubmitExamAlert = ({
  submitExam,
  showCloseButton,
  className,
  disabled,
}: SubmitExamAlertProps) => {
  const rootStyle = classnames("submit-exam-alert", className);

  const [isOpenSubmitExam, setOpenSubmitExam] = React.useState(false);
  const [isOpen, setOpen] = React.useState(true);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={rootStyle}>
      <Alert
        className="submit-exam-alert__alert"
        type="warning"
        showIcon={false}
      >
        <div className="submit-exam-alert__content">
          <div>
            <div>
              <p className="submit-exam-alert__content__title">
                <strong>
                  <Msg id={"editor-exam-submit.dontForget"} />
                </strong>
              </p>
              <p className="submit-exam-alert__content__subtitle">
                <Msg id={"editor-exam-submit.dontForget.subText"} />
              </p>
            </div>
          </div>
          <div>
            {submitExam && (
              <Button
                disabled={disabled}
                onClick={() => setOpenSubmitExam(true)}
                type="warning"
              >
                <Msg id="button.submitExam" />
              </Button>
            )}
            {showCloseButton && (
              <button
                className="delete"
                aria-label="Close"
                onClick={() => setOpen(false)}
              />
            )}
          </div>
        </div>
      </Alert>
      {isOpenSubmitExam && (
        <Portal>
          <SubmitExam
            isOpen={isOpenSubmitExam}
            onCancel={() => setOpenSubmitExam(false)}
            onSubmit={() => {
              submitExam?.();
              setOpenSubmitExam(false);
            }}
          />
        </Portal>
      )}
    </div>
  );
};
